import _extends from "@babel/runtime/helpers/esm/extends";
import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M14.75 1L1 14.75l2.2 2.2c.55-.55 1.237-.825 1.925-.825a2.758 2.758 0 0 1 2.75 2.75c0 .825-.275 1.512-.825 1.925l2.2 2.2L23 9.25l-2.2-2.2c-.413.55-1.1.825-1.925.825a2.758 2.758 0 0 1-2.75-2.75c0-.825.275-1.513.825-1.925L14.75 1z"
});

var SvgTicketFilled = function SvgTicketFilled(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgTicketFilled;